export interface Theme {
  id: string;
  label: string;
  preview: [string, string, string]; // [background, primary, text]
}

export const themes: Theme[] = [
  { id: 'default',  label: 'Discgo',   preview: ['#F5F5DC', '#2B8B3B', '#000000'] },
  { id: 'midnight', label: 'Midnight', preview: ['#0f172a', '#38bdf8', '#f1f5f9'] },
  { id: 'coral',    label: 'Coral',    preview: ['#fff8f5', '#f97316', '#1c1917'] },
  { id: 'violet',   label: 'Violet',   preview: ['#faf5ff', '#8b5cf6', '#1e1b4b'] },
  { id: 'sky',      label: 'Sky',      preview: ['#f0f9ff', '#0ea5e9', '#0c4a6e'] },
  { id: 'rose',     label: 'Rose',     preview: ['#fff1f2', '#f43f5e', '#4c0519'] },
  { id: 'amber',    label: 'Amber',    preview: ['#fffbeb', '#f59e0b', '#451a03'] },
  { id: 'forest',   label: 'Forest',   preview: ['#f0fdf4', '#16a34a', '#14532d'] },
  { id: 'neon',     label: 'Neon',     preview: ['#0a0014', '#ff00ff', '#00ffff'] },
];

export function applyTheme(themeId: string) {
  if (themeId === 'default') {
    document.documentElement.removeAttribute('data-theme');
  } else {
    document.documentElement.setAttribute('data-theme', themeId);
  }
}
